// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles-module_modal_2MQ9R","body":"styles-module_body_31QRS"};